import axios from 'axios';

import { getAuthorizationHeader } from '../utils/getAuthHeader';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8081'}`;
const url = `${API_URL}/users/roles/`;

export const fetchRoles = async () => {
  const result = await axios.get(`${url}all`, { headers: getAuthorizationHeader() });
  return result.data;
};

export const getRoleConflicts = async (roleId, permissionId, isAdding) => {
  const result = await axios.get(
    `${url}${roleId}/permissions/${permissionId}/conflicts`,
    {
      headers: getAuthorizationHeader(),
      params: { isAdding },
    }
  );
  return result.data;
};

export const syncRolePermission = async (
  roleId,
  permissionId,
  isAdding,
  overrideUserIds
) => {
  const result = await axios.put(
    `${url}${roleId}/permissions/${permissionId}/sync`,
    overrideUserIds,
    {
      headers: getAuthorizationHeader(),
      params: { isAdding },
    }
  );
  return result.data;
};

export const deactivateRole = async (id) => {
  const result = await axios.delete(`${url}${id}`, { headers: getAuthorizationHeader() });
  return result.data;
};

export const createRole = async ({ roleName, description, permissions }) => {
  const result = await axios.post(
    `${API_URL}/users/roles`,
    { roleName, description, permissions },
    { headers: getAuthorizationHeader() }
  );
  return result.data;
};

export const updateRole = async (id, { roleName, description }) => {
  const result = await axios.put(
    `${url}${id}`,
    { roleName, description },
    { headers: getAuthorizationHeader() }
  );
  return result.data;
};

export const getRolePermissionStrings = async (roleId) => {
  const result = await axios.get(`${url}${roleId}/permissions`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const fetchAllPermissions = async () => {
  const result = await axios.get(`${API_URL}/users/permissions/all`, {
    headers: getAuthorizationHeader(),
  });
  return result.data;
};

export const bulkSyncRole = async (roleId) => {
  const result = await axios.put(
    `${url}${roleId}/bulk-sync`,
    {},
    { headers: getAuthorizationHeader() }
  );
  return result.data;
};

export const exportRolesCSV = async () => {
  const result = await axios.get(`${API_URL}/csv/download/roles`, {
    headers: getAuthorizationHeader(),
    responseType: 'blob',
  });
  return result.data;
};

export const importRolesCSV = async (formData) => {
  const result = await axios.post(`${API_URL}/csv/upload/roles`, formData, {
    headers: { ...getAuthorizationHeader(), 'Content-Type': 'multipart/form-data' },
  });
  return result.data;
};

export const archiveAndMigrateRole = async (oldRoleId, newRoleId) => {
  const result = await axios.put(
    `${url}${oldRoleId}/archive-and-migrate`,
    {},
    {
      headers: getAuthorizationHeader(),
      params: { newRoleId },
    }
  );
  return result.data;
};

export const unarchiveRole = async (id) => {
  const result = await axios.put(
    `${url}${id}/unarchive`,
    {},
    { headers: getAuthorizationHeader() }
  );
  return result.data;
};
